import { getConfig } from '@/utils/config';
import { useQuery } from '@tanstack/react-query';

export const useMaintenanceCheckQuery = () => {
  return useQuery({
    queryKey: ['maintenance'],
    queryFn: async () => {
      try {
        const response = await fetch(
          `${getConfig().api.baseUrl}/maintenance/status`,
        );

        if (response.status === 503) {
          return true;
        }

        if (response.status === 200) {
          return false;
        }
      } catch {
        return false;
      }
    },
    enabled: getConfig().featureFlags.maintenanceCheck,
  });
};
